<template>
  <div class="form-wrap">
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="140px"
             class="ruleForm">
      <base-title :title="`基本信息`"></base-title>
      <el-form-item label="专题名称："
                    prop="topic_name">
        <el-input v-model="ruleForm.topic_name"
                  placeholder="请输入专题名称"></el-input>
      </el-form-item>
      <el-form-item label="专题slogan："
                    prop="slogan">
        <el-input v-model="ruleForm.slogan"
                  placeholder="请输入专题slogan"></el-input>
      </el-form-item>

      <el-form-item label="关联大主题："
                    prop="topic_type">
        <el-select v-model="ruleForm.topic_type"
                   placeholder="请选择关联大主题"
                   clearable
                   style="width:100%">
          <el-option label="系列课"
                     value="1"></el-option>
          <el-option label="企业专场"
                     value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="专题节数："
                    prop="course_number">
        <el-input-number v-model="ruleForm.course_number"
                         :min="1"
                         label="请输入专题节数"
                         style="width:100%;"></el-input-number>
      </el-form-item>
      <el-form-item label="专题介绍："
                    prop="course_introduction">
        <el-input v-model="ruleForm.course_introduction"
                  placeholder="请输入专题简介"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 8}"></el-input>
      </el-form-item>
      <el-form-item label="适合人群："
                    prop="course_audience">
        <el-input v-model="ruleForm.course_audience"
                  placeholder="请输入适合人群"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 8}"></el-input>
      </el-form-item>
      <el-form-item label="常见问题："
                    prop="common_problem">
        <el-input v-model="ruleForm.common_problem"
                  placeholder="请输入常见问题"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 8}"></el-input>
      </el-form-item>
      <el-form-item label="专题封面：">
        <div class="upload-image">
          <upload-cover tips="图片尺寸为750*424，JPG、PNG格式；图片用在首页banner"
                        img_height="130"
                        :autoSize="750/424"
                        @uploadSuccess="uploadCourse"
                        :coverImg="ruleForm.topic_cover"></upload-cover>

          <upload-cover img_height="130"
                        :autoSize="686/260"
                        tips="图片尺寸为686*260，JPG、PNG格式；图片用在首页系列课、企业专场"
                        @uploadSuccess="uploadPub"
                        :coverImg="ruleForm.publicity_cover"></upload-cover>

          <upload-cover img_height="130"
                        :autoSize="666/642"
                        tips="图片尺寸为666*316，JPG、PNG格式；图片用在生成卡片"
                        @uploadSuccess="uploadCard"
                        :coverImg="ruleForm.card_cover"></upload-cover>
        </div>
      </el-form-item>
      <el-form-item label="添加课程：">
        <ul class="course-list"
            v-if="course.length>0">
          <li v-for="(item,index) in course"
              :key="index">
            <span class="title">{{item.name}}</span>
            <el-button type="text"
                       size="mini"
                       @click="delCourse(index)">
              <i class="el-icon-delete el-icon--right"></i>
            </el-button>
          </li>
        </ul>
        <el-button type="primary"
                   @click="addCourse">
          <i class="el-icon-plus"></i>添加课程
        </el-button>
      </el-form-item>

      <base-title :title="`商品信息`"></base-title>
      <el-form-item label="售卖方式："
                    prop="topic_sell_mode">
        <el-radio-group v-model="ruleForm.topic_sell_mode">
          <el-radio :label="1">付费</el-radio>
          <el-radio :label="2">免费</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品价格："
                    v-if="ruleForm.topic_sell_mode===1"
                    prop="topic_sell_price">
        <el-input v-model="ruleForm.topic_sell_price"
                  placeholder="请输入商品价格"
                  style="width: 150px"></el-input>
      </el-form-item>
      <base-title :title="`上架设置`"></base-title>

      <el-form-item label="上架设置："
                    prop="state">
        <el-radio-group v-model="ruleForm.state">
          <el-radio :label="2"
                    class="block mt10">立即上架</el-radio>
          <el-row class="mt20">
            <el-radio :label="1"
                      class="iblock">定时上架</el-radio>
            <el-form-item label
                          prop="published_at"
                          class="iblock"
                          v-if="ruleForm.state==1">
              <el-date-picker v-model="ruleForm.published_at"
                              type="datetime"
                              placeholder="选择定时上架时间"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-row>
          <el-radio :label="3"
                    class="block mt20">暂不上架</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="首页banner展示：">
        <el-switch
          v-model="ruleForm.home_page_banner"
          active-color="#13ce66"
          inactive-color="#808080"
        ></el-switch>
        {{ruleForm.home_page_banner ? '展示' : '不展示'}}
      </el-form-item> -->

      <div class="submit-wrap tc">
        <el-button class="submit-btn"
                   type="primary"
                   @click="submit('ruleForm')">提交</el-button>
      </div>
    </el-form>

    <add-course-dialog :addCourseVisible.sync="addCourseVisible"
                       @submitData="submitData"></add-course-dialog>

  </div>
</template>

<script>
import AddCourseDialog from "../../play-template/add-course-dialog.vue";
import UploadCover from "@/components/upload-cover.vue";
import Title from "../../play-template/title.vue";

import qs from "qs"

import {
  _topicAdd,
  _topicEdit
  //专题创建
} from "@/api/topic";

export default {
  props: {
    formData: {
      type: Object,
      default: {}
    },
    topic_id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    formData (val) {
      for (const key in this.ruleForm) {
        this.ruleForm[key] = this.formData[key]
      }
      this.ruleForm.topic_type += ''
    }
  },
  data () {
    // const published_at = (rule, value, callback) => {
    //   // if (new Date(value) < new Date()) {
    //   //   callback(new Error('开始时间必须大于当前时间'))
    //   // } else 
    //   if(!value){
    //     callback(new Error('请选择开始时间'))
    //   }else{
    //     callback();
    //   }
    // }
    return {
      addCourseVisible: false,
      add_course: true,
      course: [],
      ruleForm: {
        topic_name: "", //专题名称
        course_number: '',//专题的节数
        slogan: '',//专题slogan
        topic_cover: "", //专题封面
        publicity_cover: "", //专题宣传封面
        topic_cover: '',//课程图片
        card_cover: '',//卡片图片
        topic_sell_mode: 1, //专题售卖方式,1:付费;2:免费
        topic_sell_price: "", //专题售卖价格【topic_sell_mode为1时必填】
        home_page_banner: true, //首页banner,1:上;0 不上
        state: 1, //课程上架设置,-1:删除;1:定时上架;2:上架;3:下架/不上架
        topic_type: "1", //专题分类 1: 系列课 2: 企业专场
        published_at: "", //上架时间
        course_introduction: "", //关联的专题ID
        course_audience: "", //适合人群
        common_problem: "",//	常见问题
        course_ids: []
      },
      rules: {
        topic_name: [
          { required: true, message: "请输入专题名称", trigger: "blur" }
        ],
        topic_type: [
          { required: true, message: '请选择关联的主题', trigger: 'change' }
        ],
        course_number: [
          { required: true, message: "请输入专题的节数", trigger: "blur" }
        ],
        slogan: [
          { required: true, message: "请输入专题slogan", trigger: "blur" }
        ],
        course_introduction: [
          { required: true, message: "请输入专题介绍", trigger: "blur" }
        ],
        course_audience: [
          { required: true, message: "请输入适合人群", trigger: "blur" }
        ],
        common_problem: [
          { required: true, message: "请输入常见问题", trigger: "blur" }
        ],
        topic_sell_mode: [
          { required: true, message: "请选择售卖方式", trigger: "change" }
        ],
        topic_sell_price: [
          { required: true, message: "请输入商品价格", trigger: "blur" }
        ],
        published_at: [
          {
            required: true,
            message: "请选择定时上架时间",
            trigger: "change"
          }
        ]
      }
    };
  },
  created () { },
  methods: {
    addCourse () {
      this.addCourseVisible = true;
    },
    uploadCourse (url) {
      // console.log(data,type);
      // return;
      this.ruleForm.topic_cover = url;
    },
    uploadPub (url) {
      // console.log(url);
      this.ruleForm.publicity_cover = url;
    },
    uploadCard (url) {
      // console.log(url);
      this.ruleForm.card_cover = url;
    },
    // uploadLive(url) {
    //   // console.log(url);
    //   this.ruleForm.live_cover = url;
    // },
    delCourse (index) {
      this.course.splice(index, 1);
    },
    submitData (val1, val2) {
      this.course = val2;
    },
    topicSubmit (api, data) {
      //添加提交信息接口
      //加loading效果
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)"
      });
      //添加数据处理
      data.home_page_banner == true ? data.home_page_banner = 1 : 0;
      //添加关联课程的选择
      data.course_ids = this.course.map(item => {
        return item.id
      })
      var data = qs.stringify(data);
      api({
        data: data
      }).then(res => {
        loading.close();
        if (res.resultCode == 1) {
          // console.log(res);
          this.$message.success(res.errorMsg);
          // 操作成功后跳转列表页面
          setTimeout(() => {
            this.$router.push({ path: "/course/speciallist" });
          }, 1000);
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    submit (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log("submit!");
          //添加数据处理
          if (this.isEdit) {
            this.ruleForm.topic_id = this.topic_id;
            this.topicSubmit(_topicEdit, { ...this.ruleForm });
          } else {
            this.topicSubmit(_topicAdd, { ...this.ruleForm });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  components: {
    AddCourseDialog,
    UploadCover,
    "base-title": Title
  }
};
</script>

<style lang="less" scoped>
.form-wrap {
  padding: 20px;
  background: #ffffff;
  .ruleForm {
    .upload-image {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    max-width: 1000px;
  }
  .course-list {
    li {
      line-height: 24px;
      .title {
        width: 200px;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: middle;
      }
    }
  }
  .submit-btn {
    width: 200px;
  }
}
</style>
